<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="450")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
          slot="activator" 
          class="mr-2"
          small 
          title='Copy PV' 
          color="orange" 
          v-bind="attrs"
          v-on="on"
        ) filter_none

    v-card(class="pa-4")
      v-card-title(class="headline") Copy Payment Voucher
      v-card-text Are you sure you want to copy this Payment Voucher?

      v-card-actions(class="mt-5")
        v-spacer

        v-btn(
            @click="dialog = false"
            class="custom__padding-btn elevation-0 mr-2"
        ) NO

        v-btn(
            color="blue-secondary",
            @click="submitPaymentVoucher()"
            class="elevation-0 custom__padding-btn"
        ) YES

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";

export default {
  name: 'CopyIMPV',
  props: {
    imNo: String,
  },
  data: () => ({
    dialog: false,
    overlay: false
  }),
  methods: {
    /**
     * Handle copying of Payment Voucher (imType = 8)
     * Uses dedicated PV endpoint to prevent interference with other imemo types
     */
    submitPaymentVoucher() {
        const endpoint = process.env.VUE_APP_API_OLD + `/api/duplicatePV`;

        this.overlay = true;

        axios
        .post(endpoint, { _id: this.imNo })
        .then(resp => {
          this.handleSuccess(resp);
        }).catch((err) => {
          this.handleError(err);
        });
    },

    /**
     * Handle successful copy response for Payment Voucher
     * Routes user to PV edit page
     */
    handleSuccess(resp) {
        this.overlay = false;
        this.dialog = false;
        
        const insertedId = resp.data.insertedId;
        this.$router.push(`/pv/edit/${insertedId}`);
        
        this.$toasted.success('Payment Voucher copied successfully', { icon: 'check_circle' });
    },

    /**
     * Handle error response for Payment Voucher copy operation
     */
    handleError(err) {
        this.overlay = false;
        this.dialog = false;
        
        const errorMsg = (err.response && err.response.data && err.response.data.message) 
          || err.message 
          || 'Failed to copy Payment Voucher';
        
        this.$toasted.error(errorMsg, { icon: 'error' });
    }
  }
};
</script>

<style scoped>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #1976D2 !important;
    }
</style>
